import { render, staticRenderFns } from "./MatrixLetras.vue?vue&type=template&id=b9aabf58&"
import script from "./MatrixLetras.vue?vue&type=script&lang=js&"
export * from "./MatrixLetras.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports